export default {
      id: "common__delete_lg-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__delete_lg",
      toString: function () {
        return this.url;
      }
    }